<bzg-modal-header>
  <span class="bmc-delete-confirmation__header bzg-modal__header" [ngClass]="{'bmc-delete-confirmation__header-custom': deleteProperty(data.title)}" *ngIf="includesReset(data.title)">{{ data.title | translate | titlecase }}</span>
  <span class="bmc-delete-confirmation__header bzg-modal__header" *ngIf="!includesReset(data.title)">{{ data.title | translate | uppercase }}</span>
</bzg-modal-header>
<bzg-modal-content class="bmc-delete-alert__body">
  <span [innerHTML]="data.message | translate"></span>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="delete()" [color]="'error'">{{ data.button || 'GLOBAL.DELETE' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
